import { formatPrice } from "helpers";

const SumComp = (props: { sumAmountInfo: { name: string, isCurrency?: boolean }[] | undefined, isSelectable: boolean, titles: any[], currency: any, title: string, sumInfo: any[] }) => {
    const { sumAmountInfo, isSelectable, titles, currency, title, sumInfo } = props
    const getSumValue = (args: { colName: string }) => {
        const { colName } = args
        const isCurrency = sumAmountInfo?.find(x => x.name === colName)?.isCurrency
        if (sumInfo) {
            const val = sumInfo.find((y: any) => y[colName]);
            if (val) return `${formatPrice(val[colName])} ${isCurrency ? currency.fa_title : ""}`
        } else
            return ""



    }
    return (
        <tr
            key={sumAmountInfo?.length}
            className={
                "item-data-table bg-[#f2f5fc] text-[#7e8c9e]"
            }
        >
            {isSelectable && <td></td>}
            <td>{title}</td>
            {
                titles.map((title, key) => {
                    return <td key={key}>{getSumValue({ colName: title.key })}</td>
                })
            }</tr>
    );
}

export default SumComp;